// import qs from 'qs';
import http from '@/utils/request';

// 查询流量分析
export const queryFlowData = (params) => {
  const url = '/flowAnalyze/queryFlowData';
  return http.get({
    url,
    params,
  });
};

// 查询用户数分析
export const queryUserCount = (params) => {
  const url = '/flowAnalyze/queryUserCount';
  return http.get({
    url,
    params,
  });
};

// 查询pv趋势
export const queryPvTendency = (params) => {
  const url = '/flowAnalyze/queryPvTendency';
  return http.get({
    url,
    params,
  });
};

// 查询uv趋势
export const queryUvTendency = (params) => {
  const url = '/flowAnalyze/queryUvTendency';
  return http.get({
    url,
    params,
  });
};

// 查询新用户趋势
export const queryNewUserTendency = (params) => {
  const url = '/flowAnalyze/queryNewUserTendency';
  return http.get({
    url,
    params,
  });
};

// 查询跳出率趋势
export const queryQuickExitScaleTendency = (params) => {
  const url = '/flowAnalyze/queryQuickExitScaleTendency';
  return http.get({
    url,
    params,
  });
};

// 查询平均停留时长趋势
export const queryPageDurationTendency = (params) => {
  const url = '/flowAnalyze/queryPageDurationTendency';
  return http.get({
    url,
    params,
  });
};

// 查询留存用户趋势
export const queryKeepUserTendency = (params) => {
  const url = '/flowAnalyze/queryKeepUserTendency';
  return http.get({
    url,
    params,
  });
};

// 查询排行榜分析
export const queryTopAnalyze = (params) => {
  const url = '/topAnalyze/queryTopAnalyze';
  return http.get({
    url,
    params,
  });
};

// 查询流量分析
export const queryHealthData = (params) => {
  const url = '/healthAnalyze/queryHealthData';
  return http.get({
    url,
    params,
  });
};

// 查询客户端错误趋势
export const queryClientErrorTendency = (params) => {
  const url = '/healthAnalyze/queryClientErrorTendency';
  return http.get({
    url,
    params,
  });
};

// 查询接口错误趋势
export const queryApiErrorTendency = (params) => {
  const url = '/healthAnalyze/queryApiErrorTendency';
  return http.get({
    url,
    params,
  });
};

// 查询客户端错误统计
export const queryClientErrorStat = (params) => {
  const url = '/healthAnalyze/queryClientErrorStat';
  return http.get({
    url,
    params,
  });
};

// 查询接口错误统计
export const queryApiErrorStat = (params) => {
  const url = '/healthAnalyze/queryApiErrorStat';
  return http.get({
    url,
    params,
  });
};

// 查询客户端错误概要
export const queryClientErrorSummary = (params) => {
  const url = '/healthAnalyze/queryClientErrorSummary';
  return http.get({
    url,
    params,
  });
};

// 查询接口错误概要
export const queryApiErrorSummary = (params) => {
  const url = '/healthAnalyze/queryApiErrorSummary';
  return http.get({
    url,
    params,
  });
};

// 查询客户端错误埋点行为
export const queryClientErrorBehavior = (params) => {
  const url = '/healthAnalyze/queryClientErrorBehavior';
  return http.get({
    url,
    params,
  });
};

// 查询接口错误埋点行为
export const queryApiErrorBehavior = (params) => {
  const url = '/healthAnalyze/queryApiErrorBehavior';
  return http.get({
    url,
    params,
  });
};

// 查询会话埋点行为
export const querySessionBehavior = (params) => {
  const url = '/healthAnalyze/querySessionBehavior';
  return http.get({
    url,
    params,
  });
};

// 查询错误处理信息
export const queryErrorProcessInfo = (params) => {
  const url = '/errorProcess/queryErrorProcessInfo';
  return http.get({
    url,
    params,
  });
};

// 错误处理
export const addErrorProcessInfo = (data) => {
  const url = '/errorProcess/process';
  return http.post({
    url,
    data,
  });
};
